function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import * as React from 'react';
import { getGridCellElement, getGridColumnHeaderElement, getGridRowElement } from "../../../utils/domUtils.js";
import { useGridApiMethod } from "../../utils/useGridApiMethod.js";
import { gridFocusCellSelector, gridTabIndexCellSelector } from "../focus/gridFocusStateSelector.js";
import { gridListColumnSelector } from "../listView/gridListViewSelectors.js";
export var MissingRowIdError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(MissingRowIdError, Error1);
    function MissingRowIdError() {
        _class_call_check(this, MissingRowIdError);
        return _call_super(this, MissingRowIdError, arguments);
    }
    return MissingRowIdError;
}(_wrap_native_super(Error));
/**
 * @requires useGridColumns (method)
 * @requires useGridRows (method)
 * @requires useGridFocus (state)
 * @requires useGridEditing (method)
 * TODO: Impossible priority - useGridEditing also needs to be after useGridParamsApi
 * TODO: Impossible priority - useGridFocus also needs to be after useGridParamsApi
 */ export function useGridParamsApi(apiRef, props) {
    var _props_unstable_listColumn;
    var getColumnHeaderParams = React.useCallback(function(field) {
        return {
            field: field,
            colDef: apiRef.current.getColumn(field)
        };
    }, [
        apiRef
    ]);
    var getRowParams = React.useCallback(function(id) {
        var row = apiRef.current.getRow(id);
        if (!row) {
            throw new MissingRowIdError("No row with id #".concat(id, " found"));
        }
        var params = {
            id: id,
            columns: apiRef.current.getAllColumns(),
            row: row
        };
        return params;
    }, [
        apiRef
    ]);
    var getCellParamsForRow = React.useCallback(function(id, field, row, param) {
        var cellMode = param.cellMode, colDef = param.colDef, hasFocus = param.hasFocus, rowNode = param.rowNode, tabIndex = param.tabIndex;
        var rawValue = row[field];
        var value = (colDef === null || colDef === void 0 ? void 0 : colDef.valueGetter) ? colDef.valueGetter(rawValue, row, colDef, apiRef) : rawValue;
        var params = {
            id: id,
            field: field,
            row: row,
            rowNode: rowNode,
            colDef: colDef,
            cellMode: cellMode,
            hasFocus: hasFocus,
            tabIndex: tabIndex,
            value: value,
            formattedValue: value,
            isEditable: false,
            api: null
        };
        if (colDef && colDef.valueFormatter) {
            params.formattedValue = colDef.valueFormatter(value, row, colDef, apiRef);
        }
        params.isEditable = colDef && apiRef.current.isCellEditable(params);
        return params;
    }, [
        apiRef
    ]);
    var getCellParams = React.useCallback(function(id, field) {
        var _props_unstable_listColumn;
        var row = apiRef.current.getRow(id);
        var rowNode = apiRef.current.getRowNode(id);
        if (!row || !rowNode) {
            throw new MissingRowIdError("No row with id #".concat(id, " found"));
        }
        var cellFocus = gridFocusCellSelector(apiRef);
        var cellTabIndex = gridTabIndexCellSelector(apiRef);
        var cellMode = apiRef.current.getCellMode(id, field);
        return apiRef.current.getCellParamsForRow(id, field, row, {
            colDef: props.unstable_listView && ((_props_unstable_listColumn = props.unstable_listColumn) === null || _props_unstable_listColumn === void 0 ? void 0 : _props_unstable_listColumn.field) === field ? gridListColumnSelector(apiRef.current.state) : apiRef.current.getColumn(field),
            rowNode: rowNode,
            hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1,
            cellMode: cellMode
        });
    }, [
        apiRef,
        props.unstable_listView,
        (_props_unstable_listColumn = props.unstable_listColumn) === null || _props_unstable_listColumn === void 0 ? void 0 : _props_unstable_listColumn.field
    ]);
    var getCellValue = React.useCallback(function(id, field) {
        var colDef = apiRef.current.getColumn(field);
        var row = apiRef.current.getRow(id);
        if (!row) {
            throw new MissingRowIdError("No row with id #".concat(id, " found"));
        }
        if (!colDef || !colDef.valueGetter) {
            return row[field];
        }
        return colDef.valueGetter(row[colDef.field], row, colDef, apiRef);
    }, [
        apiRef
    ]);
    var getRowValue = React.useCallback(function(row, colDef) {
        var field = colDef.field;
        if (!colDef || !colDef.valueGetter) {
            return row[field];
        }
        var value = row[colDef.field];
        return colDef.valueGetter(value, row, colDef, apiRef);
    }, [
        apiRef
    ]);
    var getRowFormattedValue = React.useCallback(function(row, colDef) {
        var value = getRowValue(row, colDef);
        if (!colDef || !colDef.valueFormatter) {
            return value;
        }
        return colDef.valueFormatter(value, row, colDef, apiRef);
    }, [
        apiRef,
        getRowValue
    ]);
    var getColumnHeaderElement = React.useCallback(function(field) {
        if (!apiRef.current.rootElementRef.current) {
            return null;
        }
        return getGridColumnHeaderElement(apiRef.current.rootElementRef.current, field);
    }, [
        apiRef
    ]);
    var getRowElement = React.useCallback(function(id) {
        if (!apiRef.current.rootElementRef.current) {
            return null;
        }
        return getGridRowElement(apiRef.current.rootElementRef.current, id);
    }, [
        apiRef
    ]);
    var getCellElement = React.useCallback(function(id, field) {
        if (!apiRef.current.rootElementRef.current) {
            return null;
        }
        return getGridCellElement(apiRef.current.rootElementRef.current, {
            id: id,
            field: field
        });
    }, [
        apiRef
    ]);
    var paramsApi = {
        getCellValue: getCellValue,
        getCellParams: getCellParams,
        getCellElement: getCellElement,
        getRowValue: getRowValue,
        getRowFormattedValue: getRowFormattedValue,
        getRowParams: getRowParams,
        getRowElement: getRowElement,
        getColumnHeaderParams: getColumnHeaderParams,
        getColumnHeaderElement: getColumnHeaderElement
    };
    var paramsPrivateApi = {
        getCellParamsForRow: getCellParamsForRow
    };
    useGridApiMethod(apiRef, paramsApi, 'public');
    useGridApiMethod(apiRef, paramsPrivateApi, 'private');
}
